import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import corporateProfileImg from "../../../assets/images/corporat_profile.webp";

const CorporateProfile = () => {
  return (
<div align="center">	
    
     
		      <h1 align="center"><strong>会社概要</strong></h1>
	    
		<table style={{width: '65%', border: "1px solid #000", align: 'center' }}>
		<tr><th style={{ backgroundColor: "#e7f7f9", borderBottom: "1px solid #ccc", padding: "10px", width: "20%" }}><h2>会社名 </h2></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>DGフューチャーテック・インディア・プライベート・リミテッド</td></tr>
	
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%"}}><h3>設立</h3></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>2012年10月</td></tr>
	
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}><h3>資本金 </h3></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>200万インドルピー</td></tr>
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}>本社 </th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>Office No.5, Gokhale Sanchit, BMCC Rd, 846 Shivajinagar, Pune 411004, India</td></tr>
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}>日本支店 </th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>〒150-0022 東京都渋谷区恵比寿南3-5-7 デジタルゲートビル10F </td></tr>
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}><h3 >従業員 </h3></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>従業員数 97 名 (2025年12月現在）</td></tr>

	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}><h3>役員 </h3></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>  <ul className="list-disc pl-4">
                      

			<li> CEO兼創設者：アナンド シラルカール </li>
                      <li className="mt-1"> COO兼共同創設者：ガウタム クルカルニ</li>
                      <li className="mt-1">取締役：ラケシュ シェンベカール（DGフィナンシャルテクノロジー 執行役員 CSTO）</li>
                        <li className="mt-1">取締役：篠 寛（DGフィナンシャルテクノロジー 代表取締役社長共同COO）</li>
                        <li className="mt-1">取締役：赤尾 浩平（DGフィナンシャルテクノロジー 取締役CTO）</li>
                    </ul>
		</td></tr>
		
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}><h3>事業内容  </h3></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}><ul className="list-disc pl-4">
                      <li>マネージドサービス（システム運用支援、システム保守)</li>
                      <li className="mt-1"> システムソリューションサービスの提供</li>
                      <li className="mt-1">アプリケーション開発</li>
                    </ul>
		</td></tr>
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}><h3>株主 </h3></th><td style={{ borderBottom: "1px solid #ccc", padding: "10px", }}>
                      株式会社DGフィナンシャルテクノロジー <br/>
		      (デジタルガレージグループ）​

		</td></tr>
		
	<tr><th style={{ borderBottom: "1px solid #ccc", padding: "10px", backgroundColor: "#e7f7f9", width: "20%" }}>お問い合わせ​ </th><td style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>
	日本国内へのお問い合わせ:<br/>
	   TEL: +81 03-6367-3830<br/>
	インドへのお問い合わせ:<br/>
	   Email: contact@dgfuturetech.com<br/>
                </td></tr>
		</table>
       
        
    </div>
 );
};

export default CorporateProfile;

